import { useDispatch, useSelector } from "react-redux";
import { USER, USERALL, COMPANY, PROJECT } from "../../services/actions";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Container, Box, Grid, Pagination } from "@mui/material";
import InfoCard2 from "../extra/InfoCard2";
import Form from "./Form";
import ActionBar from "../extra/ActionBar";
import SearchBar from "../extra/SearchBar";
import XTable from "../extra/XTableAnother";
import { layouts } from "chart.js";
import MoreInfo from "../extra/MoreInfo";

export default function View() {
  let dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});
  const [view, setView] = React.useState(1); // Added state for view
  const [companies, setCompanies] = React.useState([]);
  const [page, setPage] = React.useState(0); // current page
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchUsers = (page = 0) => {
    const url = page === 0 ? `user/${page}/` : `user/?page=${page}`; // pass page number
    dispatch({ type: `${USERALL}_GET`, payload: url });
  };

  let projectState = useSelector((state) => state?.projectState);
  let companyState = useSelector((state) => state?.companyState);
  let userState = useSelector((state) => state?.userState);
  let userallState = useSelector((state) => state?.userallState);
  let user = useSelector((state) => state?.loginState?.auth);

  React.useEffect(() => {
    try {
      dispatch({ type: `${COMPANY}_GET`, payload: 0 });
      //dispatch({ type: `${USERALL}_GET`, payload: 0 })
      fetchUsers(0);
    } catch (err) { }
  }, []);

  React.useEffect(() => {
    fetchUsers(page);
  }, [page]);

  React.useEffect(() => {
    setCompanies(companyState?.data?.results);
  }, [companyState?.data]);

  React.useEffect(() => {
    if (userState.success) {
      setOpen(false);
      dispatch({ type: `${USERALL}_GET`, payload: 0 });
    }
  }, [userState?.data]);

  // Handle filter search
  const handleSearch = (key, value) => {
    console.log(key, value);
    const query = `user/0/?filter_by={"${key}__istartswith":"${value}"}`;
    dispatch({ type: `${USERALL}_GET`, payload: query });
  };

  // Prepare data for XTable
  const tableHeadings = [
    "ID",
    "Image",
    "First Name",
    "Username",
    "Role",
    "Company",
    "Status",
  ];
  const tableRows = userallState?.data?.results?.map((user) => ({
    id: user.id, // Include ID to find the original data on edit
    image: user.avatar,
    first_name: user.first_name,
    username: user.username,
    main_role: user.main_role,
    project_count: user.company_name,
    is_active: user.is_active ? "Active" : "Inactive",
  }));

  const handleEdit = (data) => {
    // Find the original user data from the Redux state
    const originalData = userallState?.data?.results.find(
      (u) => u.id === data.id
    );

    if (originalData) {
      // Process permissions and company data before setting
      originalData.company =
        originalData.companies.length > 0 ? originalData.companies[0].id : 0;
      originalData.permissions.forEach((per) => {
        let pers = [
          "camera.can_view_timelapse",
          "camera.can_view_aicamera",
          "camera.can_view_livecam",
        ];
        if (pers.includes(per)) {
          let _t = per.split(".")[1];
          originalData[_t] = true;
        }
      });
      setDefV(originalData);
      setOpen(true);
    }
  };

  const handleDelete = (id) => {
    dispatch({ type: `${USER}_DELETE`, payload: id });
  };

  return (
    <>
      {open ? (
        <Box sx={{ p: 2 }}>
          <Form
            companies={companyState?.data?.results}
            projects={projectState?.data?.results}
            defaultValues={defV}
            onSubmit={(data) => {
              console.log("DATA-X", data);
              let creds = {
                id: data.id,
                username: data.username,
                password: data.password,
              };
              console.log("hello", data.project);
              data.project = (data.project || []).map((p) =>
                p && typeof p === "object" && "id" in p ? p.id : p
              );
              let user_info = {
                id: data.id,
                first_name: data.first_name,
                last_name: data.last_name,
                company: data.company,
                main_role: data.main_role ? data.main_role : "User",
                project: data.project,
                is_active: data.is_active,
                can_view_timelapse: data.can_view_timelapse,
                can_view_livecam: data.can_view_livecam,
                can_view_aicamera: data.can_view_aicamera,
                phone: data.phone,
                country_code: data.country_code,
              };
              let payload = {};
              if (data.action == "info") {
                payload = user_info;
              } else if (data.action.toUpperCase() === "CHANGE PASSWORD") {
                payload = creds;
              } else {
                payload = { ...creds, ...user_info };
              }
              let ACTION = data.id ? `${USER}_PATCH` : `${USER}_POST`;
              dispatch({ type: ACTION, payload: payload });
            }}
            onChange={(action, value) => {
              if (value) {
                dispatch({
                  type: `${PROJECT}_GET`,
                  payload: `project/0/?filter_by={"company":"${value}"}`,
                });
              }
            }}
            back={() => {
              setOpen(false);
            }}
          />
        </Box>
      ) : (
        <Container maxWidth="false" className="py-3">
          <ActionBar
            showGrid={[2, 5]}
            onBtnClick={(type, col) => {
              if (type === "grid") {
                setView(1);
              }
              if (type === "tabular") {
                setView(2);
              }
            }}
            hasPermission={user?.permissions?.includes("authentic.add_user")}
            label="User"
            setOpen={(s) => {
              setDefV({}); // Reset default values
              setOpen(true);
            }}
            btnLabel="ADD USER"
          />

          <SearchBar
            bylist={[
              { key: "first_name", label: "First Name" },
              { key: "companyuser__company__company_name", label: "Company name" },
              { key: "projectuser__project__project_name", label: "Project name" },
            ]}
            handleSearch={handleSearch}
          />

          {view === 1 && (
            <>
              <Grid container spacing={1} alignItems="stretch">
                {userallState?.data?.results?.map((data) => {
                  console.log(JSON.stringify(data));
                  data.image = user;
                  // data.project_count = data.projects?.length; // Added project count for display
                  return (
                    <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }} >
                      <InfoCard2
                        type="user"
                        keys={[
                          "image",
                          "first_name",
                          "username",
                          "main_role",
                          "Projects",
                          "project_count",
                          "Timelapse",
                          "timelapse_camera_count",
                          "Network",
                          "live_camera_count",
                          "last_name",
                        ]}
                        data={data}
                        onClick={() => {
                          //navigate("/timelapse-preview/", {})
                        }}
                        onAction={(action, data) => {
                          if (action == "Edit") {
                            handleEdit(data); // Call the shared edit handler
                          } else if (action == "Delete") {
                            handleDelete(data.id); // Call the shared delete handler
                          } else if (action == "More") {
                            setDefV(data);
                            setView(3);
                          }
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Pagination
                  count={Math.ceil(userallState?.data?.count / pageSize)}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </Box>
            </>
          )}

          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={handleEdit} // Use the shared handler
              onDelete={handleDelete} // Use the shared handler
            />
          )}
          {view === 3 && (
            <MoreInfo
              data={{
                ...defV,
                is_active: defV.is_active ? "Yes" : "No",
                // verify: defV.verify ? "Yes" : "No",
              }}
              skip={[
                "avatar",
                "address",
                "refresh_token",
                "token",
                "is_social_login",
                "shared_key",
                "whatsapp_number"

              ]}
              group={["first_name", "last_name", "username", "created_at"]}
              // icons={{ access_loation: <BsCopy /> }}
              // css={{ access_location: { color: '#1976d2' } }}
              onClose={() => {
                setView(1);
              }}
            />
          )}
        </Container>
      )}
    </>
  );
}
